import { FC } from 'react';
import { Tooltip } from '@brg/ui';
import { ReactComponent as MoreCircleSvg } from './assets/book-more-circle.svg';
import { BookEvents } from '../helper/bookEvents';
import { BookTooltip } from '../tooltips';
import { BookTooltipProps } from '../tooltips/BookTooltip';

type PropsT = BookTooltipProps & BookEvents;

export const BookCardTools: FC<PropsT> = (props) => (
  <Tooltip target={<MoreCircleSvg />}>
    <BookTooltip {...props} />
  </Tooltip>
);
import { FC } from 'react';
import { Tooltip } from '@brg/ui';
import { ReactComponent as MoreCircleSvg } from './assets/book-more-circle.svg';
import { BookEvents } from '../helper/bookEvents';
import { BookTooltip } from '../tooltips';
import { BookTooltipProps } from '../tooltips/BookTooltip';

type PropsT = BookTooltipProps & BookEvents;

export const BookCardTools: FC<PropsT> = (props) => (
  <Tooltip target={<MoreCircleSvg />}>
    <BookTooltip {...props} />
  </Tooltip>
);
